var map = {
	"./AM.png": 8565,
	"./Angular.png": 2041,
	"./Checkmate-logo.jpeg": 8471,
	"./Coordea-logo.jpg": 5844,
	"./Net_Framework.png": 7679,
	"./Python.png": 8485,
	"./SEEU-logo-preview.png": 6094,
	"./Upwork-logo.png": 6227,
	"./address_image.svg": 8415,
	"./animated_ashutosh.png": 4054,
	"./animated_logo.svg": 4838,
	"./blogs_image.svg": 1108,
	"./cloud_infrastructure.svg": 5820,
	"./codeInLogo.png": 9384,
	"./contactMail.png": 3914,
	"./coursera_logo.png": 8857,
	"./data_science.svg": 8712,
	"./deeplearning_ai_logo.png": 774,
	"./delhivery_logo.png": 7311,
	"./developerActivity.svg": 9504,
	"./dsc_logo.png": 3979,
	"./education.svg": 1803,
	"./experience.svg": 1071,
	"./feelingProud.svg": 2677,
	"./freecopy_logo.png": 1434,
	"./fullstack.svg": 1272,
	"./gcp_logo.png": 4375,
	"./github_logo.png": 9214,
	"./googleAssistant.jpg": 3440,
	"./googleAssistant.svg": 9650,
	"./google_logo.png": 6038,
	"./i-solve.jpeg": 41,
	"./ibm_logo.png": 5539,
	"./icon-96.webp": 5996,
	"./iiitk_logo.png": 2837,
	"./intel_logo.jpg": 1021,
	"./iu_logo.png": 8291,
	"./jsFramework.svg": 4406,
	"./legato_logo.png": 7147,
	"./manOnTable.svg": 3350,
	"./microsoft_logo.png": 3953,
	"./mozilla_logo.png": 9105,
	"./muffito_logo.png": 3981,
	"./nestjs.png": 8856,
	"./nextuLogo.jpg": 8846,
	"./nptel_logo.png": 3862,
	"./portfolio.gif": 7888,
	"./programmer.svg": 2075,
	"./projects_image.svg": 5739,
	"./pwa.png": 7399,
	"./saayaHealthLogo.png": 4123,
	"./stanford_logo.png": 4216,
	"./talksCardBack.svg": 7175,
	"./talksCardBackAlt.svg": 6740,
	"./tiktok_logo.png": 7427,
	"./ui_ux_design.svg": 7880,
	"./wn-logo.png": 3962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;